import { NGXLogger } from 'ngx-logger';

import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../../common/services/local-storage.service';
import { ContextData } from '../models/context-data';
import { RouteStateService } from '../services/route-state.service';
import { isNullOrEmpty } from '../utils';

/**
 * 路徑安全控制
 *
 * @export
 * @class AppGuard
 * @implements {CanActivateChild}
 */
@Injectable()
export class AppGuard implements CanActivateChild {
  constructor(
    private router: Router,
    private routeStateService: RouteStateService,
    private contextData: ContextData,
    private logger: NGXLogger,
    private localStorageService: LocalStorageService
  ) {}

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    if (childRoute.children.length > 0) {
      return true;
    }
    if (state.url === '/') {
      // 清掉 companyId，因為首頁為入口
      this.contextData.companyId = undefined;
      return true;
    }
    if (state.url === '/reload') {
      return true;
    }

    const stateData =
      this.router.getCurrentNavigation()?.extras?.state?.['routeState']?.data;
    const storageData =
      this.routeStateService.getRouteData(state.url)?.data ?? {};
    const queryData = childRoute.queryParams ?? {};
    const pathData = childRoute.params ?? {};
    const data = childRoute.data ?? {};

    const routeData = {
      ...(stateData ?? storageData),
      ...queryData,
      ...pathData,
      ...data,
    };
    if (isNullOrEmpty(routeData.companyId) === false) {
      this.contextData.companyId = Number(routeData.companyId);
    }

    if (
      isNullOrEmpty(this.contextData.companyId) &&
      globalThis.sigv.appContext.envConfig?.isIgnoreCompanyId === false
    ) {
      this.logger.info(
        'AppGuard - canActivateChild: Redirect to home. (No company id.)'
      );
      this.router.navigate(['/']);
      return false;
    }

    // 檢查是否有開通從外部直接 url 連進來
    const isReloadPage = state.url === this.routeStateService.routeUrl;
    if (
      this.routeStateService.isLanding === false &&
      !state.url.includes('externalFunc/')
    ) {
      if (isReloadPage === false && !routeData.grantExternalAccess) {
        this.logger.info(
          `AppGuard - canActivateChild: Redirect to home. (Route from external.)`,
          routeData
        );
        this.router.navigate(['/']);
      }
    }

    // 如果有帶 lang 參數且 reload 的話要移除 lang 參數
    const urlTree = this.router.parseUrl(state.url);
    if (urlTree.queryParams['lang'] && isReloadPage) {
      delete urlTree.queryParams['lang'];
      const url = urlTree.toString();
      this.router.navigateByUrl(url);
    }

    return true;
  }
}
